<!-- <mat-accordion class="repository-accordion">
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                {{ 'repository.index' | translate }}
            </mat-panel-title>
            <mat-panel-description style="justify-content: flex-end;">
                {{ 'repository.index-sub' | translate }}
            </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="repository-action">
            <button mat-raised-button color="primary" (click)="createIndex()">
                <mat-icon>add</mat-icon>
                {{ 'button.add-index' | translate }}
            </button>
        </div>
        <app-index-grid #IndexsGridComponent></app-index-grid>
    </mat-expansion-panel>

    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                {{ 'repository.materials' | translate }}
            </mat-panel-title>
            <mat-panel-description style="justify-content: flex-end;">
                {{ 'repository.materials-sub' | translate }}
            </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="repository-action">
            <button mat-raised-button color="primary" (click)="createMaterial()">
                <mat-icon>add</mat-icon>
                {{ 'button.add-material' | translate }}
            </button>
            <mat-form-field style="margin-left:20px;height: 30px;width: 90%;">
                <input #MaterialsGridFilter matInput type="text" autocomplete="off"
                    placeholder="{{ 'label.search' | translate }}">
            </mat-form-field>
        </div>
        <app-materials-grid #MaterialsGridComponent [filter]="MaterialsGridFilter.value"></app-materials-grid>
    </mat-expansion-panel>

    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                {{ 'repository.site-mode' | translate }}
            </mat-panel-title>
            <mat-panel-description style="justify-content: flex-end;">
                {{ 'repository.site-mode-sub' | translate }}
            </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="repository-action">
            <button mat-raised-button color="primary" (click)="createSiteMode()">
                <mat-icon>add</mat-icon>
                {{ 'button.add-site-mode' | translate }}
            </button>
        </div>
        <app-site-mode-grid #SiteModeGridComponent></app-site-mode-grid>
    </mat-expansion-panel>

    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                {{ 'repository.access-type' | translate }}
            </mat-panel-title>
            <mat-panel-description style="justify-content: flex-end;">
                {{ 'repository.access-type-sub' | translate }}
            </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="repository-action">
            <button mat-raised-button color="primary" (click)="createAccessType()">
                <mat-icon>add</mat-icon>
                {{ 'button.add-access-type' | translate }}
            </button>
        </div>
        <app-access-type-grid #AccessTypeGridComponent></app-access-type-grid>
    </mat-expansion-panel>

    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                {{ 'repository.ship' | translate }}
            </mat-panel-title>
            <mat-panel-description style="justify-content: flex-end;">
                {{ 'repository.ship-sub' | translate }}
            </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="repository-action">
            <button mat-raised-button color="primary" (click)="createShip()">
                <mat-icon>add</mat-icon>
                {{ 'button.add-ship' | translate }}
            </button>
            <mat-form-field style="margin-left:20px;height: 30px;width: 90%;">
                <input #ShipGridFilter matInput type="text" autocomplete="off"
                    placeholder="{{ 'label.search' | translate }}">
            </mat-form-field>

        </div>
        <app-ship-grid #ShipGridComponent [filter]="ShipGridFilter.value"></app-ship-grid>
    </mat-expansion-panel>

</mat-accordion> -->

<mat-tab-group #tabGroup>
    <mat-tab>
        <ng-template mat-tab-label>
            <span>{{ 'repository.index' | translate }}</span>
        </ng-template>
        <div style="width: 100%;">
            <div class="repository-action">
                <button mat-raised-button color="primary" (click)="createIndex()">
                    <mat-icon>add</mat-icon>
                    {{ 'button.add-index' | translate }}
                </button>
            </div>
            <app-index-grid #IndexsGridComponent></app-index-grid>
        </div>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <span>{{ 'repository.materials' | translate }}</span>
        </ng-template>
        <div style="width: 100%;">
            <div class="repository-action">
                <button mat-raised-button color="primary" (click)="createMaterial()">
                    <mat-icon>add</mat-icon>
                    {{ 'button.add-material' | translate }}
                </button>
                <mat-form-field style="margin-left:20px;height: 30px;width: 90%;">
                    <input #MaterialsGridFilter matInput type="text" autocomplete="off"
                        placeholder="{{ 'label.search' | translate }}">
                </mat-form-field>
            </div>
            <app-materials-grid #MaterialsGridComponent [filter]="MaterialsGridFilter.value"></app-materials-grid>
        </div>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <span>{{ 'repository.site-mode' | translate }}</span>
        </ng-template>
        <div style="width: 100%;">
            <div class="repository-action">
                <button mat-raised-button color="primary" (click)="createSiteMode()">
                    <mat-icon>add</mat-icon>
                    {{ 'button.add-site-mode' | translate }}
                </button>
            </div>
            <app-site-mode-grid #SiteModeGridComponent></app-site-mode-grid>
        </div>
    </mat-tab>
    <!-- <mat-tab>
        <ng-template mat-tab-label>
            <span>{{ 'repository.access-type' | translate }}</span>
        </ng-template>
        <div style="width: 100%;">
            <div class="repository-action">
                <button mat-raised-button color="primary" (click)="createAccessType()">
                    <mat-icon>add</mat-icon>
                    {{ 'button.add-access-type' | translate }}
                </button>
            </div>
            <app-access-type-grid #AccessTypeGridComponent></app-access-type-grid>
        </div>
    </mat-tab> -->
    <mat-tab>
        <ng-template mat-tab-label>
            <span>{{ 'repository.ship' | translate }}</span>
        </ng-template>
        <div style="width: 100%;">
            <div class="repository-action">
                <button mat-raised-button color="primary" (click)="createShip()">
                    <mat-icon>add</mat-icon>
                    {{ 'button.add-ship' | translate }}
                </button>
                <mat-form-field style="margin-left:20px;height: 30px;width: 90%;">
                    <input #ShipGridFilter matInput type="text" autocomplete="off"
                        placeholder="{{ 'label.search' | translate }}">
                </mat-form-field>

            </div>
            <app-ship-grid #ShipGridComponent [filter]="ShipGridFilter.value"></app-ship-grid>
        </div>
    </mat-tab>

    <mat-tab>
        <ng-template mat-tab-label>
            <span>{{ 'repository.default-price' | translate }}</span>
        </ng-template>
        <div style="width: 100%;">
            <app-price></app-price>
        </div>
    </mat-tab>

</mat-tab-group>